<li class="menu-item" nz-menu-item>
  <div class="horizontal seperate" [ngClass]="['is-locked']">
    <div class="menu-text">{{ title }}</div>
    <span nz-icon style="font-size: 18px" class="material-symbols-rounded">lock</span>
  </div>
</li>
